const notFoundSelector = state => state.notFound.redirectNotFound;
export default notFoundSelector;